import {AppState} from '../states/app.state';
import {createSelector} from '@ngrx/store';
import {identity} from 'rxjs';

export class DeleteDialogSelectors {
  private static select = {
    isOpen: (state: AppState) => state.deleteDialog.isOpen,
    belegIds: (state: AppState) => state.deleteDialog.belegIds,
  };

  public static isDeleteDialogOpen = createSelector(this.select.isOpen, identity);
  public static belegIds = createSelector(this.select.belegIds, identity);
}
